import React from "react";
import ReactDOM from "react-dom";

const Overlay = ({ isOpen, closeModal }) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="overlay open" onClick={closeModal} aria-hidden="true" />,
    document.body
  );
};

export default Overlay;
